import React, { createContext, useCallback, useState } from "react";
import { getOrganisationUsers, getUserOrganisations } from "../api/organisations";
import { OrganisationBase, OrganisationMemberDetails } from "../core/global";


interface OrganisationContextProps {
  organisations: OrganisationBase[][] | null
  organisationUsers: OrganisationMemberDetails[] | null
  loading: boolean
  refetchOrganisations: () => void
  refetchOrganisationUsers: (id: number | string | null) => void
}

const initialValue: OrganisationContextProps = {
  organisations: null,
  loading: false,
  organisationUsers: null,
  refetchOrganisations: () => null,
  refetchOrganisationUsers: () => null
};

export const OrganisationContext = createContext<OrganisationContextProps>(initialValue);

interface OrganisationProviderProps {
  children?: React.ReactNode;
}

export const OrganisationProvider = ({ children }: OrganisationProviderProps) => {
  const [organisations, setOrganisations] = useState(initialValue.organisations);
  const [loading, setLoading] = useState(initialValue.loading)
  const [organisationUsers, setOrganisationUsers] = useState(initialValue.organisationUsers)

  const refetchOrganisationUsers = useCallback((id: number | string | null) => {
    setLoading(true)
    const _execute = async () => {
      const {response} = await getOrganisationUsers({ id})
      if (response) {
        const {organisations: _organisations} = response
        setOrganisationUsers(_organisations)
      } else {
        setOrganisationUsers(null)
      }
      setLoading(false)
    }
    _execute()
  }, [])


  const refetchOrganisations = useCallback(() => {
    setLoading(true)
    const _execute = async () => {
      const {response} = await getUserOrganisations()
      let useOrganisations = []
      if (response) {
        const {organisations: _organisations} = response
        if (_organisations && Array.isArray(_organisations) && _organisations.length > 0) {
          useOrganisations = _organisations
        }
      }
      setOrganisations(useOrganisations as OrganisationBase[][])
      setLoading(false)
    }
    _execute()
  }, [])

  // // If logged in, fetch details
  // useEffect(() => {
  //   if (organisations === null && !loading) {
  //     refetchOrganisations()
  //   }
  // }, [organisations])
  
  return (
    <OrganisationContext.Provider
      value={{
        organisations,
        loading,
        refetchOrganisations,
        organisationUsers,
        refetchOrganisationUsers,
      }}
    >
      {children}
    </OrganisationContext.Provider>
  );
};
